import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  hideTransactionDetailModal,
  setTransactionDetail,
} from 'actions/reports/transactions';
import TransactionDetail from 'components/receipt/transactions/TransactionDetail';
import styles from './TransactionDetailModal.css';

class TransactionDetailModal extends React.Component {
  render() {
    const { openTransactionDetailModal } = this.props.data.reports.transactions;
    return (
      <div>
        <Modal
          show={openTransactionDetailModal}
          onHide={this._onHide}
          bsClass="show-navbar box-detail-modal modal"
          backdrop={false}
        >
          <Modal.Body bsClass={styles['modal-body']}>
            <TransactionDetail
              dispatch={this.props.dispatch}
              onClickDoneButton={this._onClickDoneButton}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  _onHide = () => {
    this.props.dispatch(hideTransactionDetailModal());
  };

  _onClickDoneButton = () => {
    this.props.dispatch(hideTransactionDetailModal());
    this.props.dispatch(setTransactionDetail(null));
  };
}

function mapStateToProps(state) {
  // only fetch some state
  return {
    data: {
      reports: {
        transactions: state.reports.transactions,
      },
    },
  };
}

export default connect(mapStateToProps)(TransactionDetailModal);
